module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsWomen@2x.2f4c8e8.webp";